export const copyToClipboard = (text) => {
  const textarea = document.createElement('textarea')

  textarea.style.position = 'fixed'
  textarea.style.top = 0
  textarea.style.left = 0
  textarea.style.width = '2em'
  textarea.style.height = '2em'
  textarea.style.padding = 0
  textarea.style.border = 'none'
  textarea.style.outline = 'none'
  textarea.style.boxShadow = 'none'
  textarea.style.background = 'transparent'

  textarea.value = text

  document.body.appendChild(textarea)

  textarea.focus()
  textarea.select()

  try {
    document.execCommand('copy')
  } catch (e) {
    console.error(e)
    throw e
  } finally {
    document.body.removeChild(textarea)
  }
}
